import Home from './pages/Home';
import Video from './pages/Video';
import NoMatch from './pages/NoMatch';
import Project from './pages/Project';
import Funding from './pages/Funding';

const routes = [
  {
    path: '/',
    component: Project,
    exact: true,
  },
  {
    path: '/projects/:id',
    component: Funding,
    exact: true,
  },
  {
    path: '/project/:id',
    component: Home,
    exact: true,
  },
  {
    path: '/:tokenId/:mediaId',
    component: Video,
    exact: true,
  },
  {
    path: '*',
    component: NoMatch,
  },
];

export default routes;
